import React from 'react';

const NoAccess = () => <div>Upsell TBD</div>;

export default NoAccess;
